module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"OPSWAT MetaDefender Cloud","short_name":"MDCloud","start_url":"/","background_color":"#2672FB","theme_color":"#2672FB","display":"minimal-ui","icon":"src/assets/images/favicon.png","legacy":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-W2KFPM7","defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"dataLayerName":"PageRouteChange","routeChangeEventName":"route-change"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-109072247-1","head":false,"anonymize":true,"respectDNT":true,"pageTransitionDelay":0,"defer":false,"sampleRate":5,"siteSpeedSampleRate":10,"cookieDomain":"opswat.com"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
